import { Component, Host, Prop, h, Element, Watch } from '@stencil/core'
import type { CobaltIcon } from '../cobalt-icon/cobalt-icon'

@Component({
  tag: 'cobalt-link',
  styleUrl: 'cobalt-link.css'
})
export class CobaltLink {
  /**
   * This is the text of the link.
   */
  @Prop() label?: string
  /**
   * The destination of the link.
   */
  @Prop() href?: string
  /**
   * This is the title of the link. Please provide at list the name of the destination of the link.
   */
  @Prop() linkTitle?: string
  /**
   * A string indicating the design variation of the link.
   */
  @Prop() variant?: 'primary' | 'secondary' = 'primary'
  /**
   * A string indicating the size variation of the link.
   */
  @Prop() size?: 'large' | 'medium' | 'small' = 'medium'
  /**
   * A boolean indicating the disable state of the link. The `aria-disabled` attribute relies on this property.
   */
  @Prop() disabled?: boolean = false
  /**
   * A boolean indicating if the link is external or not.
   * If `true` it will open in a new tab.
   */
  @Prop() external?: boolean = false
  /**
   * A boolean indicating if the component should behave as wrapper and allow to add child like Router Link.
   */
  @Prop() routerLink?: boolean = false
  /**
   * Accept only `'chevron_right-outline' | 'arrow_right-outline' | 'square_arrow_up_right-outline'` from `@pollux-docaposte/icon-library`. By using the cobalt-link component you don't have to install it as dependency.
   *
   */
  @Prop() iconName?: Extract<CobaltIcon['name'], 'chevron_right-outline' | 'arrow_right-outline' | 'square_arrow_up_right-outline'> = null

  @Element() element: HTMLElement

  @Watch('variant')
  @Watch('size')
  @Watch('disabled')
  @Watch('iconName')
  async onPropChange(): Promise<void> {
    this.render()
  }

  componentDidLoad(): void {
    this.element.querySelector('a') && this.element.querySelector('a').setAttribute('class', `core-anchor typography-body-${this.size}-bold`)
  }

  render(): any {
    return (
      <Host>
        <core-link
          href={this.href}
          label={this.label}
          variant={this.variant}
          linkTitle={this.linkTitle}
          iconName={this.iconName}
          size={this.size}
          external={this.external}
          disabled={this.disabled}
          routerLink={this.routerLink}
        >
          {this.routerLink && <slot />}
        </core-link>
      </Host>
    )
  }
}
